// extracted by mini-css-extract-plugin
export var orderDetails = "_om-2";
export var orderImage = "_om-1";
export var orderMeta = "_om-3";
export var orderSummary = "_om-0";
export var rightArrow = "_om-4";